const FormInteractions = (function() {
	const init = function(form) {
		const registeredListeners = registerListeners(form);
	};

	const registerListeners = function(form) {

		const whereDidYouHearAboutUs = form.querySelector('select.heard-from-select')

		if (whereDidYouHearAboutUs) {
			console.log(whereDidYouHearAboutUs);
			whereDidYouHearAboutUsListener(form, whereDidYouHearAboutUs);
		}
		
		const title = form.querySelector('#form-input-titleSuffix');
		if (title) {
			titleListener(form, title);
		}
		
		const sameAddressCheckboxes = form.querySelectorAll('.js-same-address');
		if (sameAddressCheckboxes) {
			Array.from(sameAddressCheckboxes, function(checkbox, index) {
				sameAddressListener(form, checkbox, index);
			});
		}
	};

	const whereDidYouHearAboutUsListener = function(form, field) {
		let labelField = form.querySelector('input.heard-from-hidden')

		console.log(labelField);
		
		if (labelField) {
			field.addEventListener('change', function(event) {
				labelField.value = field.selectedOptions[0].innerText ?? "";
				labelField.value = labelField.value.trim();
			});
		}
	}

	const titleListener = function(form, field) {
		const otherField = form.querySelector('#form-input-titleOther');
		if (otherField) {
			if(field.value !== 'Other') {
				fieldToggle(otherField, 'hide');
			}
			field.addEventListener('change', function(event){
				if (event.target.value == 'Other') {
					fieldToggle(otherField, 'show');
				} else {
					fieldToggle(otherField, 'hide');
				}
			});
		}
	}

	const sameAddressListener = function(form, checkbox, index) {
		checkbox.addEventListener('change', function(event) {
			const state = checkbox.checked ? 'hide' : 'show';
			const travellerNumber = index + 2;
			// addressToggle(form, travellerNumber, state);
			if (state === 'show') return;
			copyAddressFromTraveller1ContactDetails(form, travellerNumber);
		});
	}

	const addressToggle = function(form, travellerNumber, state) {
		switch(state) {
			case 'show':
				form.querySelector('#' + travellerNumber + '-address-details').classList.remove('hidden');
				break;
			case 'hide':
				form.querySelector('#' + travellerNumber + '-address-details').classList.add('hidden');
				break;
		}
	}

	const copyAddressFromTraveller1ContactDetails = function(form, travellerNumber) {
		const traveller1 = {
			'addressLine1': form.querySelector('#house-number-1').value,
			'addressLine2': form.querySelector('#street-1').value,
			'addressLine3': form.querySelector('#street2-1').value,
			'city': form.querySelector('#city-1').value,
			'county': form.querySelector('#county-1').value,
			'postcode': form.querySelector('#postcode-1').value,
			'country': form.querySelector('#countryID-1').value,
			'telDaytime': form.querySelector('#telephone-daytime-1').value,
			'telMobile': form.querySelector('#telephone-mobile-1').value,
			'telHome': form.querySelector('#telephone-home-1').value,
			'telWork': form.querySelector('#telephone-work-1').value,
			'newsletter': form.querySelector('#newsletter-1').value,
			'printedNewsletter': form.querySelector('#printed-newsletter-1').value,
		}
		console.log(traveller1);
		form.querySelector('#house-number-' + travellerNumber).value = traveller1.addressLine1;
		form.querySelector('#street-' + travellerNumber).value = traveller1.addressLine2;
		form.querySelector('#street2-' + travellerNumber).value = traveller1.addressLine3;
		form.querySelector('#city-' + travellerNumber).value = traveller1.city;
		form.querySelector('#county-' + travellerNumber).value = traveller1.county;
		form.querySelector('#postcode-' + travellerNumber).value = traveller1.postcode;
		form.querySelector('#countryID-' + travellerNumber).value = traveller1.country;
		form.querySelector('#telephone-daytime-' + travellerNumber).value = traveller1.telDaytime;
		form.querySelector('#telephone-mobile-' + travellerNumber).value = traveller1.telMobile;
		form.querySelector('#telephone-home-' + travellerNumber).value = traveller1.telHome;
		form.querySelector('#telephone-work-' + travellerNumber).value = traveller1.telWork;
		form.querySelector('#newsletter-' + travellerNumber).value = traveller1.newsletter;
		form.querySelector('#printed-newsletter-' + travellerNumber).value = traveller1.printedNewsletter;
	}

	const fieldToggle = function(field, state) {
		switch(state) {
			case 'show':
				field.parentElement.style.display = 'block';
				break;
			case 'hide':
				field.parentElement.style.display = 'none';
				break;
		}
	}

	return {
		init: init
	};
})();

export default FormInteractions;